import React from 'react';
import { useTranslation } from 'react-i18next';
import Styles from './googleAddress.module.css';
import PropTypes from 'prop-types';

export default function FooterDropdown({ onAutoModeChange }) {
    const { t } = useTranslation();

    return (
        <div className={Styles['google-address-footer-dropdown']}>
            <span className={Styles['google-address-footer-dropdown-question']} onMouseDown={() => onAutoModeChange(false)}>
                {t('widget.googleAddress.footerQuestion')}
                <span className={Styles['google-address-footer-dropdown-answer']}>{t('widget.googleAddress.footerAnswer')}</span>
            </span>
            <div className={Styles['google-logo']}></div>
        </div>
    );
}

FooterDropdown.propTypes = {
    onAutoModeChange: PropTypes.func.isRequired
};
